import { render, staticRenderFns } from "./BladesDetailView.vue?vue&type=template&id=330347b2&"
import script from "./BladesDetailView.vue?vue&type=script&lang=js&"
export * from "./BladesDetailView.vue?vue&type=script&lang=js&"
import style0 from "./BladesDetailView.vue?vue&type=style&index=0&id=330347b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports